import { render, staticRenderFns } from "./form_subcategories_component.vue?vue&type=template&id=5dfa50d6&scoped=true"
import script from "./form_subcategories_component.vue?vue&type=script&lang=js"
export * from "./form_subcategories_component.vue?vue&type=script&lang=js"
import style0 from "./form_subcategories_component.vue?vue&type=style&index=0&id=5dfa50d6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfa50d6",
  null
  
)

export default component.exports